import { apiSlice } from './apiSlice';
import { EntityCostFee } from '../../@types/vehicleCostFee';

export const entityCostFeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEntityCostFeesByTourBundle: builder.query<EntityCostFee[], string>({
      query: (tourBundleId) => `/entity-cost-fees/by-tour-bundle/${tourBundleId}`,
      providesTags: ['EntityCostFee'],
    }),
    createEntityCostFee: builder.mutation<
      EntityCostFee,
      Omit<EntityCostFee, 'id' | 'createdAt' | 'updatedAt'>
    >({
      query: (data) => ({
        url: `/entity-cost-fees`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['EntityCostFee'],
    }),
    updateEntityCostFee: builder.mutation<
      EntityCostFee,
      { id: number; data: Partial<EntityCostFee> }
    >({
      query: ({ id, data }) => ({
        url: `/entity-cost-fees/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['EntityCostFee'],
    }),
    deleteEntityCostFee: builder.mutation<void, number>({
      query: (id) => ({
        url: `/entity-cost-fees/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EntityCostFee'],
    }),
  }),
});

export const {
  useGetEntityCostFeesByTourBundleQuery,
  useCreateEntityCostFeeMutation,
  useUpdateEntityCostFeeMutation,
  useDeleteEntityCostFeeMutation,
} = entityCostFeeApiSlice;
